import React, { useEffect, useState } from "react";
import * as sweetalert from "sweetalert";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import { Grid } from "@material-ui/core";
import Controls from "../global/controls/Controls";
import { useForm, Form } from "./useForm";
import packageJson from "../../../../package.json";
export const BaseUrl = packageJson.projectURlApi.BaseUrl;
export default function CreateCities() {
  const navigate = useNavigate();
  const location = useLocation();
  const [Countries, setCountries] = useState("");
  const [ErrorLocation, setErrorLocation] = useState(false);
  const [loading, setLoading] = useState(false);

  const { id } = useParams();
  const initialFValues = {
    name_ar: "",
    name: "",

  };

  const validate = (fieldValues = loginInput) => {
    let temp = { ...errors };

    if ("name" in fieldValues)
      temp.name = fieldValues.name ? "" : "هذا الحقل  مطلوب";


    setErrors({
      ...temp,
    });
    if (fieldValues == loginInput)
      return Object.values(temp).every((x) => x == "");
  };
  const {
    loginInput,
    setLogin,
    errors,
    setErrors,
    handleInputChange,
    addForm,
  } = useForm(initialFValues, true, validate);

  const handleSubmit = (e) => {
    e.preventDefault();
    
    if (validate()) {
      setLoading(true);
      const bodyFormData = new FormData();
      bodyFormData.append("name_ar", loginInput.name_ar);
      bodyFormData.append("name", loginInput.name);
 

      axios
        .post(
          `${BaseUrl}/api/country/1/cities`,
          bodyFormData,
          {
            withCredentials: true,
          }
        )
        .then((res) => {
          if (res.status === true) {
            setLoading(false);
            sweetalert(res.data.message, {
              className: "alert-div",
              button: {
                text: "تم",
              },
            }).then(() => {
              navigate("/Citeis");
            });
          } else {
            setLoading(false);
            sweetalert(res.data.message, {
              className: "alert-div",
              button: {
                text: "تم",
              },
            }).then(() => {
              navigate("/Citeis");
            });
          }
        });
    }
    
  };

  useEffect(() => {
    if(loading === true && !validate()) {
    setTimeout(() => {
      // After the timeout, reset the loading state
      setLoading(false);
      // Your other logic here
    }, 2000); // Adjust the timeout duration as needed
    }
  }, [loading]);
  return (
    <div className="main-div">
    
        <h3 className="titlepage">إضافة محافظة</h3>
     

      <Form
        className="form-group new-design"
        method="post"
        enctype="multipart/form-data"
        onSubmit={handleSubmit}
      >
        <Grid container maxWidth="sm" spacing={4}>
          <Grid item md={6} xs={12}>
            <Controls.Input
              label=" اسم المحافظة بالعربي"
              name="name_ar"
              variant="outlined"
              fullWidth
              required
              onChange={handleInputChange}
              value={loginInput.name_ar}
              className="form-control"
              error={errors.name_ar}
              type="text"
            />
          </Grid>
          <Grid item md={6} xs={12}>
            <Controls.Input
              label=" اسم المحافظة ب الانجليزي"
              name="name"
              variant="outlined"
              fullWidth
              required
              onChange={handleInputChange}
              value={loginInput.name}
              className="form-control"
              error={errors.name}
              type="text"
            />
          </Grid>
        </Grid>
   
 
          <Grid item md={6} xs={12} spacing={2} class="div-btn-submit" style={{justifyContent:'center'}}>
          {loading === true ? (
            <Controls.Button
              type="submit"
              text=<div class="spinner center">
                <div class="spinner-blade"></div>
                <div class="spinner-blade"></div>
                <div class="spinner-blade"></div>
                <div class="spinner-blade"></div>
                <div class="spinner-blade"></div>
                <div class="spinner-blade"></div>
                <div class="spinner-blade"></div>
                <div class="spinner-blade"></div>
                <div class="spinner-blade"></div>
                <div class="spinner-blade"></div>
                <div class="spinner-blade"></div>
                <div class="spinner-blade"></div>
              </div>
              variant="contained"
              className="btn-submit"
            ></Controls.Button>
          ) : (
            <Controls.Button
              type="submit"
              text="إضافة"
              onClick={addForm}
              variant="contained"
              className="btn-submit"
            ></Controls.Button>
          )}
          </Grid>
        
      </Form>
    </div>
  );
}
